import { getTenantByHost } from '@pelicargo/tenants';

import { trpc } from '../config/trpc';

export const useTenant = () => {
  const { data } = trpc.getTenantConfig.useQuery(undefined, {
    cacheTime: 6000,
  });

  return {
    config: data,
    info: getTenantByHost(),
  };
};
